import fetch from 'isomorphic-fetch';

const API_URL = process.env.REACT_APP_MD_API_URL || `https://managerdev.weddingpe.com`;
// const API_URL = `http://localhost:9000`;

export default function callApi(endpoint, method = 'get', body) {
    let token =window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : '';

    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !=='') {
        headers.Authorization = `Bearer ${token}`;
    }
    return fetch(`${API_URL}/api/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}

